/**
 * Conditional Logger Utility with Centralized Reporting
 * Only logs detailed info in development, but captures errors for reporting in production
 */

const isDev = import.meta.env.DEV

const LOGSTASH_ENDPOINT = import.meta.env.VITE_LOGSTASH_ENDPOINT || ''

// Centralized logging service
async function sendToCentralizedSystem(level, message, meta = {}) {
    if (isDev || !LOGSTASH_ENDPOINT) return

    try {
        await fetch(LOGSTASH_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                service: 'sendthenoise-frontend',
                level: level.toUpperCase(),
                message,
                meta,
                timestamp: new Date().toISOString(),
                url: window.location.href,
                userAgent: navigator.userAgent
            })
        })
    } catch {
        // Silently fail if logging system is down
    }
}

/**
 * Log debug messages (only in development)
 * @param  {...any} args - Arguments to log
 */
export function debug(...args) {
    if (isDev) {
        console.log('[DEBUG]', ...args)
    }
}

/**
 * Log info messages
 * @param  {...any} args - Arguments to log
 */
export function info(...args) {
    if (isDev) {
        console.info('[INFO]', ...args)
    }
}

/**
 * Log warning messages (always logged)
 * @param  {...any} args - Arguments to log
 */
export function warn(...args) {
    console.warn('[WARN]', ...args)
    sendToCentralizedSystem('warn', args[0], args.slice(1))
}

/**
 * Log error messages (always logged and reported)
 * @param  {...any} args - Arguments to log
 */
export function error(...args) {
    console.error('[ERROR]', ...args)
    sendToCentralizedSystem('error', args[0] instanceof Error ? args[0].message : args[0], {
        stack: args[0] instanceof Error ? args[0].stack : null,
        details: args.slice(1)
    })
}

export default {
    debug,
    info,
    warn,
    error
}